import { ComponentContext } from './ComponentContext';

export abstract class ContextualComponent<TState extends object> {
  abstract element: Element;
  protected context: ComponentContext<TState>;
  private static dataAttribute = 'data-provides-context';

  constructor() {
    this.context = new ComponentContext(this.getInitialState());
  }

  abstract getInitialState(): TState;

  attached() {
    if (this.element) {
      this.element['__component_context__'] = this.context;
      // Mark element with data attribute for discovery across composition boundaries
      this.element.setAttribute(ContextualComponent.dataAttribute, 'true');
    }
  }

  detached() {
    this.context?.destroy();
  }

  deactivate() {
    this.context?.destroy();
  }
}
